import { TonWalletUtils } from "@lib/secrets";
import { useEffect, useState } from "react";

const usePublicAddress = () => {
    const [publicAddress, setPublicAddress] = useState('');

    useEffect(() => {
        async function getPublicAddress() {
            const address = await TonWalletUtils.getV4PublicAddress()
            if (!address) return
            setPublicAddress(address)
        }
        getPublicAddress()
    }, [])

    return publicAddress
}

export default usePublicAddress
